import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languageList } from '~common/Internationalisation/language-list';

const detectionOptions = {
  // order and from where user language should be detected
  order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain', 'querystring', 'cookie'],
  // keys or params to lookup language from
  lookupLocalStorage: 'locales',
};

const languageResources = (langs) => {
  const obj = {};
  langs.forEach(lng => {
    obj[lng.value] = {
      translation: lng.translation,
    };
  });
  return obj;
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: detectionOptions,
    resources: languageResources(languageList),
    fallbackLng: 'en',
    supportedLngs: languageList.map(lang => lang.value),
    saveMissing: true,
    debug: true,
    react: {
      wait: true,
      useSuspense: false
    },
  }, err => {
    if (err) {
      console.error('Error loading translation files', err);
    }
  },
  );

export default i18n;